<template>
  <div class="notif-modal bg-gray-50 dark:bg-gray-900">
    <div class="notif-head">Notification </div>
    <div class="notif-content">
      <div v-if="dataNotif.value === null" class="w-full h-full flex justify-center items-center">
        No Notifications
      </div>
      <div v-else class="notif-value bg-white dark:bg-gray-700" v-for="(data) in dataNotif.value" v-bind:key="data.id" @click="notifClick(data)">
        <div class="flex flex-nowrap gap-2">
          <div class="notif-icon"><icon :w="'w-6'" :h="'h-6'" :path="mdiEmail"/></div>
          <div class="notif-mail" >
            <div v-if="data.doc_name === 't_comboard_detail' || data.doc_name === 't_income_accrual' || data.doc_name === 't_payment' || data.doc_name === 't_assignment_score'">
              {{ data.info }}
            </div>
            <div v-else >
              {{ data.info }}
              <!-- <div v-if="data.state === 'Approved'">
                Permission dengan nama {{ data.doc_name}} telah di Approved dengan Permission Number {{ data.doc_number}}
              </div>
              <div v-else-if="data.state === 'Waiting for Approval'">
                Permission dengan nama {{ data.doc_name}} Sedang Waiting for Approval dengan Permission Number {{ data.doc_number}}
              </div> -->
            </div>
          </div>
        </div>

        <span class="notif-time">{{data.created_at}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  /*eslint-disable*/
  import { mdiEmail } from '@mdi/js'
  import { watchEffect, ref } from '@vue/runtime-core'
  import Icon from '@/components/Icon'
  import { useRouter } from 'vue-router'
  import axios from 'axios'

    export default {
    props: {
       propData: {
         type: Object,
         default: () => ({ empty: true })
       }
    },
    components: {
      Icon
    },
    data: function () {
        return {
        }
    },
    setup (props,  { emit }) {

      const dataNotif = ref()
      const router = useRouter()


      watchEffect(() => {
        dataNotif.value = props.propData

        // console.log(dataNotif.value)
      })

      const notifClick = (data) => {
        if (data.doc_name === 't_comboard_detail') {
          router.push('/home-comboard')
        } else if (data.doc_name === 'tr_permission') {
          router.push('/permission/'+data.doc_id)
        } else{
          router.push('/notification/'+ data.id)
        }
      }

      return {
        mdiEmail,
        dataNotif,
        notifClick
      }
    }
  }
</script>
